<div
    class='agpr-chartBlock agpr-contextMenu-parent'
    [ngClass]="{
        'agpr-block--cannot-move': !block.canMove,
        'agpr-chartBlock--preview': preview
    }"
    role="group"
    [attr.aria-label]="displayElement?.title + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
>
    @if (!preview) {
        <div
            class="agpr-chartBlock-dragHandle"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
            (keydown)="dragKeydown($event)"
        ></div>
        <ul
            class="agpr-contextMenu top right"
            [id]="id + '_dashboard_top_term_chart_actionIcons'"
            role="menu"
        >
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-trash-can"
                    [tooltip]="'Dashboard.confirmDialog.deleteChart.button' | localize"
                    (click)="onAction('delete')"
                >
                </agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-pen"
                    [tooltip]="'Dashboard.chartSettingsDialog.editChart' | localize"
                    (click)="onAction('edit')"
                >
                </agpr-button>
            </li>

        </ul>
    }
    <div class="agpr-block-content">
        @if (preview && series && displayElement.topMentionsSortField !== topMentionsSortFields.custom) {
            <div class="agpr-chartBlock-watermark">
                {{ 'Reports.chart.sampleData' | localize }}
            </div>
        }

        <div class="agpr-chartBlockMetadata">
            @if (displayElement?.chartHeaderSettings) {
                @if (displayElement.chartHeaderSettings.title) {
                    <div class="agpr-chartBlockMetadata-title">
                        <label> {{ displayElement.title }} </label>
                    </div>
                }
                @if ((displayElement.chartHeaderSettings.dateRange || displayElement.chartHeaderSettings.sourceLink)
                    && displayElement.topMentionsSortField !== topMentionsSortFields.custom) {
                    <div class="agpr-chartBlockMetadata-subtitleGroup">
                        @if (displayElement?.chartHeaderSettings?.dateRange) {
                            <div
                                class="agpr-chartBlockMetadata-dateRange"
                                [agprTooltip]="displayElement.dateRangeLabel"
                                tooltipPosition="bottom"
                            >
                                {{ displayElement?.dateRangeLabel }}
                            </div>
                        }
                        @if (displayElement.chartHeaderSettings.sourceLink) {
                            <a
                                class="agpr-chartBlockMetadata-source agpr-chartBlockMetadata-sourceLink"
                                [ngClass]="{'noDate': !displayElement?.chartHeaderSettings?.dateRange}"
                                target="_blank"
                                [routerLink]="sourceRouterLink"
                                [queryParams]="sourceRouterLinkQueryParams"
                                [pTooltip]="series && series[0] ? series[0].label : ''"
                                tooltipPosition="bottom"
                                [attr.tabindex]="(series && series[0] && series[0].label) ? '0' : '-1'"
                            >
                                {{ series && series[0] ? series[0].label : '' }}
                            </a>
                        }
                    </div>
                }
            }
        </div>

        <div
            class="agpr-topMentionsChart-container"
            [ngClass]="{'noHeader': noHeader}"
        >
            @if (series) {
                <agpr-scroll-panel>
                    <agpr-top-mentions-chart
                        [displayElement]="displayElement"
                        [sortField]="displayElement?.topMentionsSortField"
                    ></agpr-top-mentions-chart>
                </agpr-scroll-panel>
            } @else {
                @if (preview) {
                    <agpr-message
                        class="agpr-topMentionsChart-noContentMessage"
                        [id]="id + '_dataSource_error'"
                        [severity]="messageSeverities.info"
                    >
                        {{ 'Reports.chart.noDataSource' | localize }}
                    </agpr-message>
                } @else {
                    <agpr-message
                        class="agpr-topMentionsChart-noContentMessage"
                        [id]="id + '_dataSource_error'"
                    [severity]="messageSeverities.error"
                    >
                        {{ 'Reports.error.folderRemoved' | localize }}
                    </agpr-message>
                }
            }
        </div>
    </div>
    <div #resizeIcon class="gridster-item-resize gridster-item-resize--right">
        <span
            class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
            role="img"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        ></span>
    </div>
    <div class="agpr-block-hoverBorder"></div>
</div>
<div *ngIf="block.errors?.length > 0" class="agpr-blockError" [id]="id + '_errors'">
    <li *ngFor="let error of block.errors">
        <agpr-form-message>
            {{ error | localize }}
        </agpr-form-message>
    </li>
</div>
